// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"4184ad00","132":"9122d58d","684":"981bfcb4","787":"71f5ef45"}[chunkId] + ".chunk.js";
};